import React, { useState, useRef, useEffect } from 'react';
import { range } from 'lodash-es';
import { pdfjs } from 'react-pdf';
import { LoadingPage } from 'components/loading';
import {
  StyledDocument,
  StyledPage,
} from 'components/modals/vnm-terms/scrollable-terms/scrollable-terms.style';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// Checkbox is not rendering without this option due to missing font files
const options = {
  standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts/`,
};

export const ScrollablePdf = ({ pdfUrl }: { pdfUrl: string }) => {
  const [numPages, setNumPages] = useState(0);
  const [width, setWidth] = useState(0);

  const ref = useRef<HTMLDivElement>(null);

  const updateWidth = () => {
    const { current } = ref;
    if (!current) return;

    setWidth(current.clientWidth);
  };

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);

    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);

  const onLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <div data-testid="scrollable-terms" ref={ref}>
      <StyledDocument
        file={pdfUrl}
        onLoadSuccess={onLoadSuccess}
        loading={<LoadingPage />}
        options={options}
      >
        {range(numPages).map(num => (
          <StyledPage
            key={num}
            pageNumber={num + 1}
            loading={<LoadingPage />}
            width={width}
          />
        ))}
      </StyledDocument>
    </div>
  );
};
